import { Milestone } from "types/collaboration";

export interface CampaignShort {
    uuid: string,
    name: string,
    hero_img_url: string,
    platform: string,
    budget: number,
    barter_budget: number,
    is_pro: boolean,
    is_upcoming: boolean,
    brand: Brand,
    requirements: Requirements,
}

export interface CampaignListResponse {
    count: number,
    items: CampaignShort[],
}

export interface CampaignReducerState {
    loading: boolean;
    error: string | null;
    filters: CampaignFilters;
    applied_filter_id: string | null;
    total: number;
    filtered_lists: Record<string, {
        list: CampaignShort[];
        count: number;
        page: number;
        last_fetched_at: number | null;
        expired: boolean;
        has_more: boolean;
    }>;
    campaignLoading: boolean;
    campaigns: Record<string, {
        data: CampaignDetail;
        last_fetched_at: number | null;
    }>
    last_fetched_at: number | null;
    all_campaigns: Campaign[];
}

export interface CampaignFilters {
    q?: string;
    page: number;
    [key: string]: any;
}

export const defaultCampaignFilters: CampaignFilters = {
    page: 1
}



export interface CampaignRequirement {
    follower_count: number;
}

interface Brand {
    name: string;
    website_url: string;
    description: string;
    category: string;
}

export interface Campaign {
    uuid: string;
    name: string;
    hero_img_url: string;
    gender_name: string;
    strategy: string;
    strategy_name?: string;
    status?: string;
    description?: string;
    niches?: string[];
    niche_names?: string[];
    speciality_niches?: string[];
    speciality_niche_names?: string[];
    posted_on?: string;
    budget?: string;
    is_pro?: boolean;
    barter_budget?: string | null,
    barter_reimbursement?: boolean,
    created?: string;
    gallery_images?: string[];
    requirement: CampaignRequirement;
    requirements?: Requirements,
    brand?: Brand;
    connection_required: boolean;
    platform: string;
    require_hub?: boolean;
    attach_social_post?: boolean;
}

export interface Requirements {
    gender?: "A" | "F" | "M",
    gender_name?: string,
    follower_count?: {
        min: number
    },
    niches?: string[],
    cities?: string[],
    regions?: string[],
    age?: {
        min?: number | null,
        max?: number | null
    },
    audience_cities?: string[],
    audience_age_groups?: any[],
    audience_gender?: "A" | "F" | "M",
    audience_gender_name?: string,
    languages?: string[];
    creator_count?: {
        min?: number | null,
        max?: number | null
    };
    creator_bucket: string
}

export interface CampaignDetail {
    share_url: string;
    campaign: Campaign;
    brand: Brand;
    milestones: Milestone[];
    questions?: ScreeningQuestion[];
    can_apply: boolean;
    can_apply_reason: string | null;
}


export enum ScreeningQuestionType {
    TEXT = 'text',
    BINARY = 'binary',
    CHOICE = 'choice'
}

export interface ScreeningQuestion {
    id: number,
    question: string,
    type: ScreeningQuestionType,
    options?: string[]
}